import { takeEvery, put, call, select, CallEffect, PutEffect, SelectEffect } from "redux-saga/effects";

import {
  GET_IN_PROGRESS_ORDER_LIST,
  GET_ORDER_LIST,

  GET_ORDER,

  GET_ORDER_MESSAGES,
  GET_LAST_ORDER_MESSAGE,
  GET_CHAT_MEMBERS,

  GET_ORDER_INK_SIGN_DOCS,

} from "./actionTypes";

import {
  getOrderListOk,
  getOrderListErr,

  getOrderOk,
  getOrderErr,

  getOrderMessagesOk,
  getOrderMessagesErr,

  getLastOrderMessageOk,
  getLastOrderMessageErr,

  getChatMembersOk,
  getChatMembersErr,

  getOrderInkSignDocsOk,
  getOrderInkSignDocsErr,

} from "./actions";

import {
  getOrders,
  getOrder,
  getOrderMessages,
  getAllOrderMessages,
  getChatMembers,
  getInkSignOrderDocs,
} from "~/helpers/backendHelper";

import OrderNotary from "~/model/orderNotary";
import {
  GetOrdersResponse,
  GetOrderResponse,
} from "~/types/backend";
import { RootState } from "..";
import { TAction } from "~/types/global";

const getFilters = (status: number): Record<string, any> => {
  switch (status) {
    case OrderNotary.VIRTUAL_STATUS_PROCESSING:
      return { excStatus: OrderNotary.STATUS_ORDER_COMPLETE };
    case OrderNotary.VIRTUAL_STATUS_COMPLETE:
      return { status: OrderNotary.STATUS_ORDER_COMPLETE };
    default:
      return {};
  }
};

/********** LIST **********/

function* onGetOrders({ payload: { params } }: TAction): Generator<SelectEffect | CallEffect | PutEffect<any>, void, any | GetOrdersResponse> {
  try {
    const filterToggle = yield select((state: RootState) => state.Order.List.filterToggle);
    const response = yield call(getOrders, { ...params, filters: getFilters(filterToggle)});
    yield put(getOrderListOk(response));
  } catch (error) {
    yield put(getOrderListErr(error as Error));
  }
}

function* onGetInProgressOrders(): Generator<CallEffect | PutEffect<any>, void, GetOrdersResponse> {
  try {
    const response = yield call(
      getOrders,
      { pageSize: 5, page: 1, filters: getFilters(OrderNotary.VIRTUAL_STATUS_PROCESSING)}
    );
    yield put(getOrderListOk(response));
  } catch (error) {
    yield put(getOrderListErr(error as Error));
  }
}

/********** SINGLE **********/

function* onGetOrder({ payload: { id } }: TAction): Generator<CallEffect | PutEffect<any>, void, GetOrderResponse> {
  try {
    const response = yield call(getOrder, id);
    yield put(getOrderOk(response));
  } catch (error) {
    yield put(getOrderErr(error as Error));
  }
}

/********** MESSAGES **********/

function* onGetOrderMessages({ payload: { orderId, channelId, params } }: TAction): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response = yield call(getOrderMessages, orderId, channelId, params);
    yield put(getOrderMessagesOk(response, channelId));
  } catch (error) {
    yield put(getOrderMessagesErr(error as Error));
  }
}

function* onGetLastMessage({ payload: { orderId } }: TAction): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response = yield call(getAllOrderMessages, orderId, { page: 1, pageSize: 1, sortBy: "id", sortDir: "desc" });
    const message = response.messages[0];
    yield put(getLastOrderMessageOk(message));
  } catch (error) {
    yield put(getLastOrderMessageErr(error as Error));
  }
}

function* onGetChatMembers({ payload: { orderId, channelId } }: TAction): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response = yield call(getChatMembers, orderId, channelId);
    yield put(getChatMembersOk(response, channelId));
  } catch (error) {
    yield put(getChatMembersErr(error as Error));
  }
}

/********** INK-SIGN DOCS **********/

function* onGetOrderInkSignDocs({ payload: { id } }: TAction): Generator<CallEffect | PutEffect<any>, void, any> {
  try {
    const response = yield call(getInkSignOrderDocs, id);
    yield put(getOrderInkSignDocsOk(response));
  } catch (error) {
    yield put(getOrderInkSignDocsErr(error as Error));
  }
}


function* orderSaga() {
  yield takeEvery(GET_ORDER_LIST, onGetOrders);
  yield takeEvery(GET_IN_PROGRESS_ORDER_LIST, onGetInProgressOrders);
  yield takeEvery(GET_ORDER, onGetOrder);

  yield takeEvery(GET_ORDER_MESSAGES, onGetOrderMessages);
  yield takeEvery(GET_LAST_ORDER_MESSAGE, onGetLastMessage);
  yield takeEvery(GET_CHAT_MEMBERS, onGetChatMembers);

  yield takeEvery(GET_ORDER_INK_SIGN_DOCS, onGetOrderInkSignDocs);
}

export default orderSaga;
